export default "__VITE_ASSET__DUInw6JA__"